__turbopack_context__.v({
  "className": "pF8mJa_className",
  "variable": "pF8mJa_variable",
});
